import React from "react";
import MaterialTable from "material-table";

function TableVehicles({ 
  open, 
  title,
  vehicles
}) {

  const tableRef = React.useRef();
  
  const getControllerStatusCell = (vehicle) => {
    let status = vehicle.getState();

    let color = "red"
    let message = "Offline"
    if (status === 0) {
      color = "darkblue";
      message = "Inactivo"
    } else if (status === 1) {
      color = "green";
      message = "Activo"
    }

    return (
      <span>
        <span style={{color: color}}>●</span> { message }
      </span>
    )
  }
  
  const getGnssStatusCell = (vehicle) => {
    let color = "red"
    let message = "Err"

    if (vehicle.gnssStatus.state === 0) {
      color = "darkblue";
      message = "Off";
    } else if (vehicle.gnssStatus.state === 1) {
      color = "yellow";
      message = `${vehicle.gnssStatus.satellites}`; 

      if (vehicle.gnssStatus.fix) {
        color = "green";
        message = `${vehicle.gnssStatus.satellites} (${vehicle.gnssStatus.fix.satellites})`;
      }
    }

    return (
      <span>
        <span style={{color: color}}>●</span> { message }
      </span>
    )
  }

  const getGsmStatusCell = (vehicle) => {
    let color = "red"
    let message = "Err"

    if (vehicle.gsmStatus.state === 1) {

      if (vehicle.gsmStatus.networkStatus === 3 || vehicle.gsmStatus.networkStatus === 6) {
        color = "red";
        message = "NetErr";
      } else if (vehicle.gsmStatus.networkStatus === 1 || vehicle.gsmStatus.networkStatus === 5) {
        color = "green";
        message = `${vehicle.gsmStatus.signalStrength} RSSI`;
      } else {
        color = "yellow";
        message = `${vehicle.gsmStatus.signalStrength} RSSI`;
      }
    } else if (vehicle.gnssStatus.state === 0 || vehicle.gnssStatus.state === 3) {
      color = "blue";
      message = "Min"; 
    }

    return (
      <span>
        <span style={{color: color}}>●</span> { message }
      </span>
    )
  }

  const getAccStatusCell = (vehicle) => {
    let color = "red"
    let message = "Err"

    if (vehicle.accelerometerStatus.state === 0) {
      color = "blue";
      message = "Off";
    } else if (vehicle.accelerometerStatus.state === 1) {
      color = "green";
      message = "Desc.";
      if (vehicle.accelerometerStatus.moving === 0)
        message = "Quieto";
      else if (vehicle.accelerometerStatus.moving === 1)
        message = "Mov.";
    }

    return (
      <span>
        <span style={{color: color}}>●</span> { message }
      </span>
    )
  }

  const getStorageStatusCell = (vehicle) => {
    let color = "red"
    let message = "Err"

    if (vehicle.vehicleStorageStatus.state === 0) {
      color = "blue";
      message = "Off";
    } else if (vehicle.vehicleStorageStatus.state === 1) {
      color = "green";
      let total = (vehicle.vehicleStorageStatus.used + vehicle.vehicleStorageStatus.free) / 1000000;
      let used = (vehicle.vehicleStorageStatus.used / 1000000) / total;
      message = `${parseFloat(used).toFixed(1)}% (${parseFloat(total).toFixed(2)}Gb)`;
    }

    return (
      <span>
        <span style={{color: color}}>●</span> { message }
      </span>
    )
  }

  return (
    <div>
      <MaterialTable
        tableRef={tableRef}
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "",
          },
          body: {
            emptyDataSourceMessage: "No hay vehiculos para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            }
          },
        }}
        title={title}
        columns={[
          { title: "ID", field: "id",  editable: "never", cellStyle: {width:"5%"}, headerStyle:{width:"5%"},
            render: rowData => <span>{rowData.eboardId}</span> },
          { title: "Estado", field: "controllerStatus.state", editable: "never", sorting: false, cellStyle: {width:"15%"}, headerStyle:{width:"15%"},
            render: rowData => getControllerStatusCell(rowData) },
          { title: "Red móvil", field: "gsmStatus.state", editable: "never", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => getGsmStatusCell(rowData) },
          { title: "Acel.", field: "accelerometerStatus.state", editable: "never", sorting: false, cellStyle: {width:"15%"}, headerStyle:{width:"15%"},
            render: rowData => getAccStatusCell(rowData) },
          { title: "Gps", field: "gnssStatus.state", editable: "never", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => getGnssStatusCell(rowData) },
          { title: "Alm.", field: "vehicleStorageStatus.state", editable: "never", sorting: false, cellStyle: {width:"20%"}, headerStyle:{width:"20%"},
            render: rowData => getStorageStatusCell(rowData) },
        ]}
        actions={[
          rowData => ({
            icon: "search",
            tooltip: "Ver detalles",
            onClick: (event, rowData) => { }
          })
        ]}
        options={{
          sorting: false,
          draggable: false,
          addRowPosition: "first",
          actionsColumnIndex: -1,
          tableLayout: 'auto',
          actionsCellStyle: {width: "5%"},
          rowStyle: {
            fontSize: 14,
          }
        }}
        data={vehicles}
      />
    </div>
  );

}


export default TableVehicles;